const DateFormat = (props) => {
  if (props.value !== null && props.value !== '' && props.value !== undefined) {
    const format = process.env.REACT_APP_DATE_FORMAT || 'DD/MM/YYYY, hh:mm A'
    const d = new Date(props.value)

    const pad = (n) => String(n).padStart(2, '0')

    const map = {
      YYYY: d.getFullYear(),
      MM: pad(d.getMonth() + 1),
      DD: pad(d.getDate()),
      hh: pad(((d.getHours() + 11) % 12) + 1), // 12-hour
      HH: pad(d.getHours()), // 24-hour
      mm: pad(d.getMinutes()),
      A: d.getHours() >= 12 ? 'PM' : 'AM'
    }

    let result = format

    Object.keys(map).forEach((key) => {
      result = result.replace(key, map[key])
    })

    return result
  } else {
    return ''
  }
}
export default DateFormat
